import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ExpandablePanel } from '../../components/widgets';
import CustomAIDimensionHeader from './CustomAIDimensionHeader';
import ExpandedDimension from './ExpandedDimension';
import CollapsedPanelValues from '../../components/widgets/CollapsedPanelValues';
import css from './CustomAIDimension.css';

const CustomAIDimension = ({
    customAIDimension,
    expanded,
    onExpand,
    onUpdate,
    onDelete,
    onCancel,
    onHasChangesChange,
}) => {
    const isNewDimension = !customAIDimension.id;
    const [displayName, setDisplayName] = useState(customAIDimension.display_name);

    useEffect(() => {
        if (!expanded) {
            setDisplayName(customAIDimension.display_name);
        }
    }, [expanded, customAIDimension.display_name]);

    const handleNameChange = newName => {
        setDisplayName(newName);
    };

    const resetDisplayName = () => {
        setDisplayName(customAIDimension.display_name);
    };

    const handleCancel = () => {
        resetDisplayName();
        onCancel();
    };

    const collapsedContent = (
        <div className={css.collapsedRow}>
            <CollapsedPanelValues values={customAIDimension.options || []} shouldSliceValues />
        </div>
    );

    return (
        <ExpandablePanel
            id={customAIDimension.id}
            expanded={expanded}
            onExpandClick={onExpand}
            header={
                <CustomAIDimensionHeader
                    customAIDimension={{ ...customAIDimension, display_name: displayName }}
                    onDelete={onDelete}
                    onNameChange={handleNameChange}
                    isExpanded={expanded}
                />
            }
            collapsedContent={collapsedContent}
            content={
                <ExpandedDimension
                    customAIDimension={{ ...customAIDimension, display_name: displayName }}
                    originalDisplayName={customAIDimension.display_name}
                    onUpdate={onUpdate}
                    onCancel={handleCancel}
                    onHasChangesChange={onHasChangesChange}
                    isNewDimension={isNewDimension}
                />
            }
            animate={expanded}
        />
    );
};

CustomAIDimension.propTypes = {
    customAIDimension: PropTypes.shape({
        id: PropTypes.number,
        app: PropTypes.string,
        description: PropTypes.string,
        display_name: PropTypes.string,
        media_type: PropTypes.number,
        value_type: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.string),
        hook_enabled: PropTypes.bool,
        hook_duration: PropTypes.number,
    }),
    expanded: PropTypes.bool,
    onExpand: PropTypes.func,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
    onCancel: PropTypes.func,
    onHasChangesChange: PropTypes.func,
};

export default CustomAIDimension;
